export default __webpack_public_path__ + "static/media/Dynamic-Data-Layer.d1627abc.png";